import { Component, OnChanges, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ListItemRendererComponent } from 'gung-list';
import {
  AuthService,
  DigitalAsset,
  DigitalAssetFile,
  DigitalAssetsGridViewComponent,
  DigitalAssetsService,
  GungModalService
} from 'gung-standard';
import { DateUtilService } from 'gung-common';
import { GungUser as User } from 'gung-standard';
import { first } from 'rxjs';

@Component({
    selector: 'colmec-digital-assets-grid-view',
    templateUrl: './colmec-digital-assets-grid-view.component.html',
    styleUrls: ['./colmec-digital-assets-grid-view.component.scss'],
    standalone: false
})
export class ColmecDigitalAssetsGridViewComponent
  extends ListItemRendererComponent<DigitalAsset[]>
  implements OnInit, OnChanges
{
  currentUser: User;
  isManagement = false;
  parentId: string;

  selectedDigitalAsset: DigitalAsset;

  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected gungModalService: GungModalService,
    protected authService: AuthService,
    private modalService: NgbModal,
    public dateUtilService: DateUtilService,
    protected digitalAssetsService: DigitalAssetsService
  ) {
    super();
  }

  ngOnInit() {
    this.parentId = undefined;
    this.authService
      .getCurrentUser()
      .pipe(first())
      .subscribe(user => (this.currentUser = user));
    if (this.route.snapshot.url.length > 1) {
      this.parentId = this.route.snapshot.url[this.route.snapshot.url.length - 2].path;
    }
    this.isManagement = this.router.url.startsWith('/digital-assets/management');
  }

  ngOnChanges() {
    this.ngOnInit();
  }

  download(digitalAsset: DigitalAsset) {
    const imageS3Uris: string[] = this.selectedDigitalAsset.images
      .filter(i => i.extra._selected)
      .map(i => 'fit-in/5000x5000/filters:quality(100):background_color(white)/' + i.s3Uri);
    const documentsToSend: DigitalAssetFile[] = this.selectedDigitalAsset.documents.filter(i => i.extra._selected);
    if (imageS3Uris.length > 0 || documentsToSend.length > 0) {
      this.digitalAssetsService.sendDigitalAssetsFilesUri(
        imageS3Uris,
        documentsToSend,
        this.gungModalService,
        this.currentUser.email
      );
    } else {
      this.digitalAssetsService.sendDigitalAssetsFiles([digitalAsset], this.gungModalService, this.currentUser.email);
    }
    this.selectedDigitalAsset = undefined;
  }

  open(content, digitalAsset: DigitalAsset) {
    this.selectedDigitalAsset = digitalAsset;
    this.selectedDigitalAsset.images.forEach(i => (i.extra._selected = false));
    this.selectedDigitalAsset.documents.forEach(d => (d.extra._selected = false));
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }).result.then(
      result => {},
      reason => {}
    );
  }
}
